import { useReduxState } from 'hooks';
import { CodeInput } from 'components/common/form/common';
import { EditorBlockTranslationReference } from 'components/editor';

interface Props {
  isPreview: boolean;
  language?: string;
  onChange: (text: string) => void;
  placeholder: string;
  showLineNumbers?: boolean;
  style?: React.CSSProperties;
  text: string;
  title?: React.ReactNode;
  translationReferenceBackgroundColor?: string;
  translationReferenceLanguage: string | null;
  translationReferenceText: string | null;
}

const PreEditor = ({
  isPreview,
  language,
  onChange,
  placeholder,
  showLineNumbers = false,
  style,
  text,
  title,
  translationReferenceBackgroundColor,
  translationReferenceLanguage,
  translationReferenceText
}: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="pre-editor" style={style}>
      {title ? <div className="title">{title}</div> : null}

      <EditorBlockTranslationReference
        backgroundColor={translationReferenceBackgroundColor || theme.lightGrey}
        referenceHtml={translationReferenceText}
        isCode={true}
        isEnabled={Boolean(
          translationReferenceText && translationReferenceLanguage
        )}
        isInnerElement={true}
        style={{ marginBottom: 10, marginTop: 5 }}
        translationHtml={text}
      >
        <CodeInput
          disabled={isPreview}
          language={language}
          onValueChange={onChange}
          placeholder={placeholder}
          rows={1}
          showLineNumbers={showLineNumbers}
          value={text || ''}
        />
      </EditorBlockTranslationReference>

      <style jsx>{`
        .pre-editor {
          background-color: ${theme.lightGrey};
          border-radius: ${theme.cardBorderRadius};
          color: ${theme.textColorLight};
          font-size: 1.4rem;
          padding: 15px;
        }
        .title {
          font-size: 1.4rem;
          font-weight: 700;
          line-height: 1;
          margin-bottom: 10px;
        }
        .pre-editor :global(.vuo-code-editor) {
          background-color: inherit;
          font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
          font-size: 1.2rem;
          counter-reset: line-number;
          line-height: 1.6;
          min-height: max-content;
          padding: 0;
        }
      `}</style>
    </div>
  );
};

export default PreEditor;
